import { render } from "./Sala5It.vue?vue&type=template&id=75ff3da3"
import script from "./Sala5It.vue?vue&type=script&lang=js"
export * from "./Sala5It.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\marco\\Desktop\\archeo-guida-smart\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__